import {
    ERROR_MESSAGES,
} from 'constants/validation-error-messages';
import * as yup from 'yup';

export const schema = yup.object({
    count: yup.number().transform((value, originalValue) => originalValue === '' ? undefined : value).required(ERROR_MESSAGES.REQUIRED).typeError(ERROR_MESSAGES.NUMBER_TYPE).min(1, ERROR_MESSAGES.NUMBER_MIN).max(30, ERROR_MESSAGES.NUMBER_MAX),
    workplace_id: yup.string().required(ERROR_MESSAGES.REQUIRED),
    department: yup.string(),
});